import { render, staticRenderFns } from "./GaleriTable.vue?vue&type=template&id=00f16e96&"
import script from "./GaleriTable.vue?vue&type=script&lang=js&"
export * from "./GaleriTable.vue?vue&type=script&lang=js&"
import style0 from "./GaleriTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports